import MODULE from "@/flit2go-web-core/interfaces/moduleConstants";
import {
  BOOKINGS,
  MODEL_LIST,
  VEHICLES_MODEL_FORM,
  TIMELINE_CREATE_OPERATION,
  BOOKINGS_FORM,
  TIMELINE,
  SUBSCRIPTIONS,
  SUBSCRIPTION_FORM,
  CATEGORY_FORM,
  CATEGORY_LIST,
  INDEX_HOME,
  MAP,
  CONTRACTS,
  VEHICLES,
  VEHICLES_OWNERS,
  BUDGETS_LIST,
  BUDGETS_TYPES,
  SEASONS_LIST,
  SEASONS_FORM,
  GROUP_SEATS_LIST,
  GROUP_SEATS_FORM,
  EXPENSES_LIST,
} from "@/modules/Vehicles/routesInterface";

const menu = {
  code: MODULE.VEHICLES.CODE,
  name: "vehicles",
  label: "common.vehicles",
  link: INDEX_HOME,
  children: [],
  createChildren: [],
};

const submenus = [
  {
    code: MODULE.VEHICLES.BOOKINGS,
    icon: "timeline",
    label: "timeline",
    link: TIMELINE,
    name: "timeline",
    tooltip: "timeline",
  },
  {
    code: MODULE.VEHICLES.DASHBOARD,
    icon: "dashboard",
    label: "common.dashboard",
    link: INDEX_HOME,
    name: "home",
    tooltip: "common.home",
  },
  {
    code: MODULE.VEHICLES.MAP,
    icon: "map-marker-1",
    label: "common.map",
    link: MAP,
    name: "map",
    tooltip: "common.map",
  },
  {
    code: MODULE.VEHICLES.VEHICLES,
    icon: "vehicles",
    label: "common.vehicles",
    link: VEHICLES,
    name: "vehicles",
    tooltip: "common.vehicles",
  },
  {
    code: MODULE.VEHICLES.EXPENSES,
    icon: "expense",
    label: "expends",
    link: EXPENSES_LIST,
    name: "expenses",
    tooltip: "expends",
  },
  {
    code: MODULE.VEHICLES.CATEGORIES,
    icon: "category",
    label: "common.categories",
    link: CATEGORY_LIST,
    name: "category",
    tooltip: "common.categories",
  },
  {
    code: MODULE.VEHICLES.GROUP_SEATS,
    icon: "seat",
    label: "groupsOfSeats",
    link: GROUP_SEATS_LIST,
    name: "groupSeats",
    tooltip: "groupsOfSeats",
  },
  {
    code: MODULE.VEHICLES.RENTALS,
    icon: "travels",
    label: "common.contracts",
    link: CONTRACTS,
    name: "contracts",
    tooltip: "common.contracts",
  },
  {
    code: MODULE.VEHICLES.BOOKINGS,
    icon: "appointment",
    label: "common.bookings",
    link: BOOKINGS,
    name: "bookings",
    tooltip: "common.bookings",
  },
  {
    code: MODULE.VEHICLES.MODELS,
    icon: "models",
    name: "models",
    label: "common.models",
    link: MODEL_LIST,
    tooltip: "common.models",
  },
  {
    code: MODULE.VEHICLES.SUBSCRIPTIONS,
    icon: "subscription",
    label: "common.subscriptions",
    link: SUBSCRIPTIONS,
    name: "subscriptions",
    tooltip: "common.subscriptions",
  },
  {
    code: MODULE.VEHICLES.BUDGETS,
    icon: "budget",
    label: "budgets",
    link: BUDGETS_LIST,
    name: "budgets",
    tooltip: "budgets",
  },
  {
    code: MODULE.VEHICLES.SEASONS,
    icon: "season",
    label: "seasons",
    link: SEASONS_LIST,
    name: "seasons",
    tooltip: "seasons",
  },
];

const submenusCreate = [
  {
    code: MODULE.VEHICLES.VEHICLES,
    name: "registerVehicle",
    label: "common.vehicle",
    link: VEHICLES_OWNERS,
  },
  {
    code: MODULE.VEHICLES.MODELS,
    name: "registerModel",
    label: "common.model",
    link: VEHICLES_MODEL_FORM,
  },
  {
    code: MODULE.VEHICLES.CATEGORIES,
    label: "common.category",
    link: CATEGORY_FORM,
    name: "registerCategory",
  },
  {
    code: MODULE.VEHICLES.GROUP_SEATS,
    label: "groupOfSeats",
    link: GROUP_SEATS_FORM,
    name: "groupSeats",
  },
  {
    code: MODULE.VEHICLES.BOOKINGS,
    label: "common.booking",
    link: BOOKINGS_FORM,
    name: "registerReserve",
  },
  {
    code: MODULE.VEHICLES.SUBSCRIPTIONS,
    label: "subscription",
    link: SUBSCRIPTION_FORM,
    name: "registerSubscription",
  },
  {
    code: MODULE.VEHICLES.BOOKINGS,
    label: "common.operation",
    link: TIMELINE_CREATE_OPERATION,
    name: "operation",
  },
  {
    code: MODULE.VEHICLES.BUDGETS,
    label: "budget",
    link: BUDGETS_TYPES,
    name: "budget",
  },
  {
    code: MODULE.VEHICLES.SEASONS,
    label: "season",
    link: SEASONS_FORM,
    name: "season",
  },
];

function getMenu(submodules) {
  menu.children = [];
  menu.createChildren = [];
  submodules.forEach((submodule) => {
    const submenuAux = submenus.filter(
      (submenu) => submenu.code === submodule.code
    );
    const submenuCreateAux = submenusCreate.filter(
      (submenu) => submenu.code === submodule.code
    );
    if (submenuAux.length && (submodule.r || submodule.w)) {
      submenuAux.forEach((submenu) => {
        menu.children.push(submenu);
      });
    }
    if (submenuCreateAux.length && submodule.w && !submodule.hasFilter) {
      submenuCreateAux.forEach((item) => {
        menu.createChildren.push(item);
      });
    }
  });
  return menu;
}

export default { getMenu };
